import { render } from "./GoaSidebarTabs.vue?vue&type=template&id=420b62ce"
import script from "./GoaSidebarTabs.vue?vue&type=script&lang=js"
export * from "./GoaSidebarTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__